import { FieldPolicy } from '@apollo/client';
import { ThirdPartyPost, ExternalRssPost } from '../models/graphql';

type Item = ThirdPartyPost | ExternalRssPost;

type SearchResult = {
  items: Item[];
  cursor?: string;
};

export const thirdPartyPostPolicy = (): FieldPolicy<SearchResult, SearchResult> => {
  return {
    keyArgs: false,
    merge(existing = { items: [], cursor: '' }, incoming) {
      const itemMap = new Map<string, Item>();

      const getKey = (item: Item): string | undefined => {
        // Use type guard to distinguish between ThirdPartyPost and ExternalRssPost
        if ('externalId' in item) {
          return item.externalId;
        } else if ('postUrl' in item && item.postUrl) {
          return item.postUrl;
        }
        return undefined;
      };

      // Process existing items
      existing.items.forEach(item => {
        const key = getKey(item);
        if (key) {
          itemMap.set(key, item);
        }
      });

      // Process incoming items
      incoming.items.forEach(item => {
        const key = getKey(item);
        if (key && !itemMap.has(key)) {
          itemMap.set(key, item);
        }
      });

      return {
        cursor: incoming.cursor ?? existing.cursor,
        items: Array.from(itemMap.values())
      };
    }
  };
};
